
















import Vue from 'vue';
import Component, { mixins } from 'vue-class-component';

import { config } from './config';

import { customizable } from '../../mixins/customizable';

import { IndexedObject } from '../../types';

const Props = Vue.extend({
	props: {
		/** Set min-height to 500px */
		minHeight: {
			type: Boolean,
			default: false
		},
		/**
		 * Customize the class binded to the VCard
		 * 'page-card' will be applied regardless of this property.
		 *
		 * This is needed since `v-bind="$attrs"` doesn't work with
		 * classes and styles.
		 */
		cardClass: {
			type: String,
			default: undefined
		},
		/**
		 * Customize the padding of the VCard
		 *
		 * Separating this from the cardClass allows to change a class
		 * without having to defining the padding if not needed
		 */
		cardPadding: {
			type: String,
			default: 'px-6 py-4'
		}
	}
});

const MixinsDeclaration = mixins(Props, customizable(config));

/**
 * PageCard is a component that displays a
 * VCard with specific parameters
 */
@Component({
	// Disable attributes inheritance since we bind them to the VCard
	inheritAttrs: false
})
export default class PageCard extends MixinsDeclaration {
	/** The CSS classes to apply to the VCard */
	get computedClass(): (string | IndexedObject<boolean>)[] {
		return [
			{ 'vd-min-height': this.minHeight },
			this.cardPadding,
			this.cardClass
		];
	}

	get paddingClass(): string {
		return this.$vuetify.breakpoint.smAndDown ? 'pa-4' : 'pa-8';
	}
}
